import { Guid, SerializableObject } from '../../common-react/core';

import { Address } from './address.do';

export class Party extends SerializableObject {
  public id: Guid;
  public identificationNumber?: string;
  public name?: string;
  public phone?: string;
  public email?: string;
  public address?: Address;

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'address':
        if (!propertyValue) {
          return undefined;
        }
        return new Address(propertyValue);

      default:
        return returnValue;
    }
  }

}
